/*
 * Copyright (c) 2019  Apricad LLC. All Rights Reserved.
 */

import { Reducer, AnyAction } from "redux";

import {
  GET_COURSES,
  GET_CURRENT_COURSE,
  GET_COURSE_IMAGE,
  GET_CURRENT_LECTURE,
  GET_COURSES_FAILED,
  GET_COURSE_FAILED,
  GET_CURRENT_LECTURE_FAILED,
  FIND_LECTURES,
  CLEAR_LEC_FOUND,
} from "../actions/types";

export enum courseType {
  COURSE = 0,
  LINK,
  ANNOUCEMENT,
}

export type CourseState = {
  readonly courses: any[];
  readonly currentCourse?: any;
  readonly currentLecture?: any;
  readonly lecFound?: any;
  readonly courseImages: any;
  readonly actionState?: string | undefined;
};

const courseReducerDefaultState: CourseState = {
  courses: [], // courses matches searching criteria, without associated data
  currentCourse: undefined, // course currently worked on, with first level associated data (lectures...)
  currentLecture: undefined, // lecture currently worked on, with infoboxes populated
  lecFound: null, // result of findLectures,
  courseImages: {},
  actionState: undefined, // for showing UX feedback after an action (e.g., update saved)
};

export const courseReducer: Reducer<CourseState, AnyAction> = (
  state: CourseState = courseReducerDefaultState,
  action: AnyAction,
) => {
  const { payload } = action;
  switch (action.type) {
    case GET_COURSES: // Update course, clear currentCourse
      return { ...state, courses: payload };

    case GET_COURSE_IMAGE: {
      const { cid, image } = action.payload;
      return {
        ...state,
        courseImages: { ...state.courseImages, [cid]: image },
      };
    }

    case GET_CURRENT_COURSE: // Update currentCourse
      return { ...state, currentCourse: payload };

    case GET_CURRENT_LECTURE:
      return { ...state, currentLecture: payload };

    case FIND_LECTURES:
    case CLEAR_LEC_FOUND:
      return { ...state, lecFound: payload };

    case GET_COURSES_FAILED:
    case GET_COURSE_FAILED:
    case GET_CURRENT_LECTURE_FAILED:
      console.log(">*> Course reducer error: ", payload);
      return state;

    default:
      return state;
  }
};
